import {
  loadPropertyOptions,
  loadUnitOptions
} from "api/landlord/asyncUnitProperties";
import { useState } from "react";
import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { useFormController } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { AsyncSelect } from "shared/components/AsyncSelect/AsyncSelect";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const InterestedInSection = ({
  form
}: {
  form: ReturnType<typeof useFormController>;
}) => {
  const { Unit, Property } = useUnitsPropertiesDictionary();

  const [unitError, setUnitError] = useState("");
  const [propertyError, setPropertyError] = useState("");

  return (
    <SectionCard title="Interested in">
      <div
        className="grid gap-4 w-full max-w-[752px]"
        style={{ gridTemplateColumns: "repeat(2,minmax(0,1fr))" }}
      >
        <div className="w-full">
          <AsyncSelect
            id="property"
            isClearable
            label={Property}
            value={form.values.property_id || ""}
            searchable={true}
            // @ts-expect-error -- meh
            loadOptions={loadPropertyOptions}
            error={propertyError}
            options={[]}
            onChange={(e) => {
              if (!Array.isArray(e)) {
                form.setPropertyId(Number(e.target.value));
                setPropertyError("");
                form.setUnitId();
              }
            }}
            additional={{
              page: 1
            }}
          />
        </div>
        <div className="w-full">
          <AsyncSelect
            id="unit"
            isClearable
            key={form.values.property_id}
            label={Unit}
            searchable={true}
            value={form.values.unit_id || ""}
            options={[]}
            // @ts-expect-error -- meh
            loadOptions={loadUnitOptions}
            error={unitError}
            additional={{ page: 1, propertyId: form.values.property_id }}
            onChange={(e) => {
              if (!Array.isArray(e)) {
                form.setUnitId(Number(e.target.value));
                setUnitError("");
              }
            }}
          />
        </div>
      </div>
    </SectionCard>
  );
};
